const HomeStyle = {
  scrolling: {
    overflowY: 'scroll',
  },
  flexBox: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    marginTop: '9em',
  },
  cardContainer: {
    width: '48em',
    height: '45em',
    overflow: 'hidden',
    background: '#FFFFFF',
    borderRadius: '16px',
    boxShadow: '0px 2px 4px -2px',
    borderTop: '1px solid grey',
    marginBottom: 20,
  },
  cardData: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '1.5em',
    lineHeight: '25px',
    color: '#34343E',
    marginTop: '1.3em',
    padding: '1.2em',
  },
  cardDiscription: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '2em',
    lineHeight: '20px',
    color: '#34343E',
    marginTop: '1.3em',
  },
  cardHeader: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '5em',
  },
  cardContent: {
    marginTop: '4em',
    marginLeft: '3em',
    marginRight: '3em',
  },
  mainHeading: {
    fontFamily: 'Montserrat',
    fontSize: '40px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '49px',
    letterSpacing: '0px',
    textAIlign: 'center',
    height: '49px',
    width: '407px',
    marginLeft: 'auto',
    marginRight: 'auto',
    top: '40px',
    borderRadius: 'null',
  },
  heading: {
    height: '40px',
    width: '500px',
    // textAIlign: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    // left: '0px',
    top: '61px',
    borderRadius: 'null',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '20px',
    // letterSpacing: '0px',
    textAlign: 'center',
  },
  boxToHoldTopBar: {
    width: '100%',
    height: '7vh', //64px
    color: 'white',
    backgroundColor: '#010101',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  boxToHoldLogo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    //border: '1px solid white',
    //width: '15vw', //145px
    height: 'inherit',
  },
  logoIconProperties: {
    height: '7vh',
    // width: 'inherit',
  },
  boxtoHoldHomeTCWorks: {
    //border: '1px solid white',
    //width: '40vw', //500px
    height: 'inherit',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
  },
  boxToHoldLoginSignupButtons: {
    //border: '1px solid white',
    //width: '25vw', //200px
    height: 'inherit',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
  },

  boxToHoldLoginButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #010101',
    height: 'inherit',
  },
  loginButtonProperties: {
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    height: 'inherit',
    padding: '1vh 1vw',
    cursor: 'pointer',
  },

  boxToHoldSignupButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #010101',
    cursor: 'pointer',
  },
  signupButtonProperties: {
    color: 'black',
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '35px',
    fontSize: '14px',
    padding: '1.5vh 3vw',
    //width: '15vw',
    //height: '4.5vw',
  },
  htcwButtonProperties: {
    fontSize: '14px',
    color: 'white',
    //border: '1px solid pink',
    padding: '0vh 2vw',
  },
  flexBoxTSGB: {
    display: 'flex',
    paddingLeft: '5vw', //170px
    paddingTop: '20vh',
    //border: '1px solid blue',
  },
  titleHoldingBox: {
    paddingBottom: '40px',
  },
  titleBox: {
    fontSize: '40px',
    width: '700px', //700px
    //border: '1px solid red',
  },
  subtitleholdingBox: {},
  subtitleBox: {
    fontSize: '18px',
    width: '500px', //500px
    //border: '1px solid red',
  },
  getStartedButtonHoldingBox: {
    paddingTop: '40px',
  },
  getStartedBox: {
    width: '500px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  getStartedButtonProperties: {
    backgroundColor: 'black',
    color: '#FAFAFA',
    fontSize: '14px',
    width: '192px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50px',
  },
};

export default HomeStyle;
